export default __webpack_public_path__ + "static/media/loading-loading-forever.213a5d77.gif";